import { Button, Grid } from "@mui/material";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import { IChartLineHideData } from "@/Dashboard/components/CustomerSatisfaction/ChartLine";
import { LegendCheckbox } from "./LegendCheckbox";

export interface ICustomLegendProps {
	showYouInfo: boolean;
	hide: IChartLineHideData;
	setHide: (value: IChartLineHideData) => void;
}

export const CustomLegend = ({ showYouInfo, hide, setHide }: Readonly<ICustomLegendProps>) => {
	return (
		<Grid container className="w-full flex justify-between pl-[25px] items-center">
			<Grid item>
				<Button disableRipple className="![text-transform:unset] !p-0 !text-[14px] !text-default h-[10px] !font-sans" size="small">
					<PersonSearchIcon className="!text-[20px] !text-[#019bd9]" />
					View My Surveys
				</Button>
			</Grid>
			<Grid className="flex justify-end gap-2" item>
				{showYouInfo && (
					<LegendCheckbox
						checked={!hide.You}
						onChange={() => setHide({ ...hide, You: !hide.You })}
						className="!text-[#019bd9] [&.Mui-checked]!text-[#019bd9]"
						label="You"
					/>
				)}

				<LegendCheckbox
					checked={!hide.Dealership}
					onChange={() => setHide({ ...hide, Dealership: !hide.Dealership })}
					className="!text-[#e41f75] [&.Mui-checked]!text-[#e41f75]"
					label="Dealership"
				/>
				<LegendCheckbox
					checked={!hide.Region}
					onChange={() => setHide({ ...hide, Region: !hide.Region })}
					label="Region"
					className="!text-[#ffa000] [&.Mui-checked]!text-[#ffa000]"
				/>
			</Grid>
		</Grid>
	);
};
